var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOstroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 21,
    viewBox: "0 0 37 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0046 6.75696C8.72212 6.75696 7.12881 8.54301 7.12881 10.7313V10.7648C7.12881 12.9531 8.7368 14.7728 11.0388 14.7728C13.3407 14.7728 14.9145 12.9867 14.9145 10.7983V10.7648C14.9145 8.57652 13.3065 6.75696 11.0046 6.75696Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.735 6.75696C24.4525 6.75696 22.8591 8.54301 22.8591 10.7313V10.7648C22.8591 12.9531 24.4676 14.7728 26.7696 14.7728C29.0715 14.7728 30.6449 12.9867 30.6449 10.7983V10.7648C30.6449 8.57652 29.037 6.75696 26.735 6.75696Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7516 0.724121H11.1585C5.49892 0.724121 0.909648 5.22044 0.909648 10.7654C0.909648 16.3104 5.49892 20.8067 11.1585 20.8067H26.7516C32.4111 20.8067 37 16.3104 37 10.7654C37 5.22044 32.4111 0.724121 26.7516 0.724121ZM17.1701 10.7654C17.1701 13.921 14.6726 16.5929 11.1439 16.5929C7.61516 16.5929 5.14703 13.9688 5.14703 10.7989V10.7654C5.14703 7.60987 7.64447 4.93792 11.1732 4.93792C14.7019 4.93792 17.1701 7.56199 17.1701 10.7319V10.7654ZM32.7676 10.7654C32.7676 13.921 30.2704 16.5929 26.7416 16.5929C23.2127 16.5929 20.7444 13.9688 20.7444 10.7989V10.7654C20.7444 7.60987 23.2422 4.93792 26.7711 4.93792C30.2993 4.93792 32.7676 7.56199 32.7676 10.7319V10.7654Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOstroIcon);
export default __webpack_public_path__ + "static/media/ostro-icon.74ff9c1bee8ceed76ffd55a5481a3815.svg";
export { ForwardRef as ReactComponent };